export default __webpack_public_path__ + "static/AD_5252_rgb-d7d8aba3da157e058fbd4adc8c360ef1.jpg";